import { AppTypeId } from '@ps/platform-message-framework/common/AppTypeId';
import { ProductId } from '@ps/platform-message-framework/common/ProductId';
import React from 'react';
import { useSelector } from 'react-redux';

import { Header } from '@swf/core/enums';
import ApolloClientProvider from '@swf/core/providers/ApolloClientProvider';
import { select } from '@swf/core/store';

const WalletApolloProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const { idpToken, installId = '' } = useSelector(select.session.get);
  const { apiDomain } = useSelector(select.config.get);
  const site = useSelector(select.cms.getSiteId);
  const deviceId = useSelector(select.device.getId);
  const osId = useSelector(select.device.getOS);
  const brandId = useSelector(select.cms.getBrandId);
  const platformId = useSelector(select.device.getPlatform);

  if (!apiDomain || !idpToken) return null;

  const wsUrl = new URL(apiDomain);
  wsUrl.protocol = 'wss';
  wsUrl.pathname = '/pam/wallet/subscription';

  const httpUrl = new URL(apiDomain);
  httpUrl.pathname = '/pam/wallet/graphql';

  const customHeaders = {
    [Header.FiSiteId]: site,
    [Header.FiDeviceId]: deviceId,
    [Header.FiInstallId]: installId,
    [Header.FiProductId]: String(ProductId.UNKNOWN),
    [Header.FiOsId]: osId,
    [Header.FiPlatformId]: platformId,
    [Header.FiBrandId]: brandId,
    [Header.FiAppTypeId]: String(AppTypeId.RAM)
  };

  return (
    <ApolloClientProvider
      wsLinkUrl={wsUrl.href}
      httpLinkUri={httpUrl.href}
      useIdpAuth
      httpHeaders={customHeaders}
    >
      {children}
    </ApolloClientProvider>
  );
};

export default WalletApolloProvider;
